export default "__VITE_ASSET__DoeF04aR__"